exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".disable-dbl-tap-zoom[data-v-2d6514e8]:focus{outline:none}.disable-dbl-tap-zoom[data-v-2d6514e8]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-touch-action:manipulation;touch-action:manipulation}", ""]);
